/*
 * Turns the Key Ingredients cards in the Supplement Facts drawer
 * (snippets/key-ingredients-card.liquid) into a Slick carousel — one card
 * per slide, prev/next arrows only (no dots), since this carousel is used
 * by desktop mouse users too, not just touch, unlike the mobile-only
 * carousel at .js-ingredient-grid-slider (ingredient-carousel.js).
 *
 * The drawer starts `display:none` (sidebar-drawer) and only becomes
 * visible when SidebarDrawer.show() runs (section-header.js). This mirrors
 * mobile-nav-overhaul.js's handling of the exact same "Slick inside a
 * sidebar that starts display:none" situation for its own carousel:
 *   - watch for the opened class via MutationObserver
 *   - delay init with a double requestAnimationFrame so the browser has
 *     finished laying out the now-visible drawer first
 *   - fully `unslick` and reinitialize fresh on every open, not just once —
 *     Slick can bake in a bad width measurement from the instant it's
 *     called (seen here producing a several-thousand-pixel slide width,
 *     overflowing the drawer); re-running it once the drawer is genuinely
 *     laid out clears that up, where a single delayed first init did not.
 */
(function () {
  const arrowSvg = (direction) => `
    <button type="button" class="sf-key-ingredients-arrow sf-key-ingredients-arrow--${direction}" aria-label="${direction === "prev" ? "Previous" : "Next"} ingredient">
      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
        <path d="M7 1L1 7L7 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  `;

  function scheduleInit() {
    requestAnimationFrame(() => {
      requestAnimationFrame(initKeyIngredientsCarousel);
    });
  }

  function initKeyIngredientsCarousel() {
    if (typeof jQuery === "undefined" || !jQuery.fn.slick) return;

    const slider = document.querySelector(".js-key-ingredients-slider");
    if (!slider) return;

    const count = parseInt(slider.dataset.count, 10) || 0;
    if (count <= 1) return;

    const $slider = jQuery(slider);
    if ($slider.hasClass("slick-initialized")) {
      $slider.slick("unslick");
    }

    $slider.slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      adaptiveHeight: true,
      waitForAnimate: false,
      prevArrow: arrowSvg("prev"),
      nextArrow: arrowSvg("next"),
    });
  }

  const sidebar = document.getElementById("supplement-facts-sidebar");
  if (!sidebar) return;

  if (sidebar.classList.contains("sidebar--opened")) {
    scheduleInit();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.attributeName === "class" &&
        sidebar.classList.contains("sidebar--opened")
      ) {
        scheduleInit();
      }
    });
  });

  observer.observe(sidebar, {
    attributes: true,
    attributeFilter: ["class"],
  });
})();
